export default __webpack_public_path__ + "static/media/HTML-removebg-preview.6f78c7f3.png";